import type { Effect, Reducer, Subscription } from '@umijs/max';
import type { UserPayType } from './data';
import { getUserPayPage } from './service';

export type UserPayState = {
  code: number;
  type: string;
  message: string;
  total: number;
  current: number;
  pageSize: number;
  items: UserPayType[];
};

type UserPayModelType = {
  namespace: string;
  state: UserPayState;
  reducers: {
    UserPayReducer: Reducer<UserPayState>;
  };
  effects: {
    fetchUserPayPageEffect: Effect;
    refreshDataEffect: Effect;
  };
  subscriptions: {
    setup: Subscription;
  };
};

const UserPayModel: UserPayModelType = {
  namespace: 'userPay',
  state: {
    code: 0,
    type: '',
    message: 'success',
    items: [],
    total: 0,
    pageSize: 20,
    current: 1,
  },

  reducers: {
    UserPayReducer(state, action) {
      const payload = action.payload || {};
      return {
        ...state,
        ...payload,
        items: payload.data?.items || [],
        total: payload.data?.total || 0,
        current: payload.data?.current || 1,
        pageSize: payload.data?.pageSize || 20,
      } as UserPayState;
    },
  },

  effects: {
    *fetchUserPayPageEffect(
      { payload: { pageSize, current, filter, sorter } }: any,
      { put, call }: any,
    ): Generator<any, void, any> {
      try {
        const res: any = yield call(getUserPayPage, {
          pageSize,
          current,
          filter,
          sorter,
        });
        yield put({
          type: 'UserPayReducer',
          payload: res,
        });
      } catch (e) {
        console.error('Fetch data failed:', e);
      }
    },

    // 通用刷新数据的 effect
    *refreshDataEffect(
      { payload: action }: any,
      { put, select }: any,
    ): Generator<any, void, any> {
      const current = yield select((state: any) => state.userPay.current);
      const pageSize = yield select((state: any) => state.userPay.pageSize);
      yield put({
        type: 'fetchUserPayPageEffect',
        payload: {
          current,
          pageSize,
          filter: { ...action.filter },
          sorter: action.sorter || [],
        },
      });
    },
  },

  subscriptions: {
    setup() {},
  },
};

export default UserPayModel;
